export const withCompPreviewInfo = () => (depsArray, resolver) => {
    const deps = depsArray.reduce((acc, key) => ({ ...acc, [key]: true }), {});
    return {
        deps,
        resolver,
    };
};
export const withCompPreviewProps = () => withCompPreviewInfo();
export function createComponentPreviewMapperModel(entry) {
    return entry;
}
//# sourceMappingURL=createComponentPreviewMapper.js.map